<template>
  <div>
    <TopBar :pagetitle="title" :back-url="backurl" />

    <van-list
      v-if="isListModel"
      v-model="loading"
      class="listBody"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div v-for="item in list" :key="item.diveCenterId" class="shopRect" @click="onSelect(item)">
        <img class="icon" :src="item.icon">
        <div class="body">
          <div class="supportLine pagebody3">
            {{ item.supportChinese?'支持中文':'' }}
          </div>
          <div class="pageTitle1 title">{{ item.title }}</div>

          <div class="pagebody3 aboutStr">{{ item.about }}</div>
          <div class="pagebody2 address">{{ getCountryText(item.country) }} {{ item.city }}</div>
        </div>
      </div>
    </van-list>

  </div></template>
<script>
import request from '@/utils/request'
import TopBar from '@/components/TopBar'
import { initPage, getUrlKey, getCountryText } from '@/utils/base'
import { Button, List } from 'vant'
export default {
  name: 'GlobalMydivecenterList',
  components: {
    [Button.name]: Button,
    [List.name]: List,
    TopBar
  },
  data() {
    return {
      offsetTop: 0,
      title: '全球潜水中心',
      backurl: '/users/index',
      isListModel: true,
      search: {
        key: undefined,
        country: '',
        course: '',
        offers: '',
        language: undefined,
        gas: undefined,
        rental: undefined,
        service: undefined,
        other: undefined,
        page: 1,
        limit: 30
      },
      mapisFirst: true, // 地图第一次使用
      mapObject: undefined, // 地图对象
      timeMapReload: undefined, // 定时刷新对象
      mapMoveStarPoing: undefined, // 记录移动起点坐标对象
      mapPointList: [], // 地图渲染列表
      mapPointDataList: [], // 地图数据列表

      list: [],
      loading: false,
      finished: false
    }
  },
  activated() {
    // keep-alive组件 页面进入的时候设置滚动高度
    console.log('activated', this.offsetTop)
    document.documentElement.scrollTop = this.offsetTop
    // 移动一下地图以免点消失
    if (this.isListModel) {
      console.log('我退回到地图页面了')
      if (this.mapObject !== undefined) {
        var selfs = this
        window.setTimeout(function() {
          selfs.mapObject.panBy(1, 0)
        }, 100)
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    // keep-alive 组件停用时调用（简单理解为组件离开的时候）。
    // 获取页面滚动高度，这个钩子有可能会拿不到数据，因为这个钩子执行的慢，可以用beforeRouteLeave代替
    console.log('beforeRouteLeave', this.offsetTop)
    this.offsetTop = document.documentElement.scrollTop
    next()
  },
  created() {
    initPage(false)
    var url = getUrlKey('backurl')
    if (url !== null) {
      this.backurl = url
    }
    this.list = []
    this.onLoad()
  },
  methods: {
    getCountryText,
    onSelect(item) {
      this.$router.replace('/store/globaldivecenter/' + item.diveCenterId + '?backurl=/store/globalMydivecenterList')
    },
    onLoad() {
      // 如果不是列表模式则执行地图模式逻辑
      if (!this.isListModel) {
        this.loadMapData()
        return
      }
      this.loading = true
      request({
        url: '/Store/getMyDiveCenterList',
        method: 'post',
        data: this.search
      }).then(response => {
        if (!response.success) {
          this.error = true
          return
        }
        this.loading = false
        this.search.limit = response.data.limit
        this.search.page = response.data.page + 1
        response.data.rows.forEach(item => {
          this.list.push(item)
        })
        if (response.data.rows.length < this.search.limit) {
          this.finished = true
        }
      })
    }
  }
}
</script>
<style scoped>
.van-search__content{
    background-color: #fff ;
}
.van-dropdown-menu{
    border-top-left-radius:1em;
    border-top-right-radius:1em;
}
.serBar{
    position: fixed;
    left: 0;
    top:3em;
    width: 100%;
    height: 3.5em;
    z-index: 10;
}
.serType{
    background-color: #f1f1f1;
    position: fixed;
    left: 0;
    top:6.5em;
    height: 3em;
    width: 100%;
    z-index: 10;
}
.van-dropdown-menu{
    height: 3em;
}
.listBody{
    margin-top: 0em;
}
.mapRect{
  border-top: 1px solid #cacaca;
  position: fixed;
  left: 0;
  right: 0;
  top:9.5em;
  bottom: 0;
}
.shopRect{
    height: 7.5em;
    border-bottom: 1px solid #f1f1f1;
    margin: 0.5em 1em;
    position: relative;
}
.shopRect .title{
    overflow: hidden;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    padding-right: 3em;
    height: 2.6em;
}
.shopRect .aboutStr{
    overflow: hidden;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    margin-top: 0.2em;
    height: 2.8em;
}
.shopRect .address{
    margin-top: 0.2em;
    height: 0.8em;
}
.shopRect .supportLine
{
    position: absolute;
    right: 0.5em;
    top: 0.5em;
    border-top:1px solid #E32119;
    border-bottom:1px solid #E32119;
    color: #E32119;
    font-weight: 700;
}
.shopRect .icon{
    height: 6.8em;
    width: 6.8em;
    padding: 0.1em;
}
.shopRect .body{
    position: absolute;
    left:7em;
    top:0;
    width: calc(100% - 8em);
    padding: 0.5em;
}

</style>
